import { Link, useLocation } from "react-router-dom";
import { Nav, NavItem } from "reactstrap";
import styles from "./Tabs.module.scss"

const Tabs = ({tabList}: TabProps) => {
    const currentLocation = useLocation();

    return (
      <Nav tabs>
        {tabList.map(tabItem => (
          <NavItem key={tabItem.name}>
              <Link
                to={tabItem.path}
                className={`${styles.navLink} ${currentLocation.pathname === tabItem.path && styles.active}`}
              >
                <span>{tabItem.name}</span>
              </Link>
          </NavItem>
        ))}
      </Nav>
    )
}

export default Tabs;

interface TabProps {
  tabList: {name: string, path: string}[];
}